import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "w-full overflow-hidden tw color-unset lineheight-unset"
};
const _hoisted_2 = {
  class: "flex overflow-hidden bg-white"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "w-48 py-4 px-6"
};
const _hoisted_5 = {
  class: "w-11/12 pr-6 pl-1"
};
const _hoisted_6 = {
  class: "flex justify-between"
};
const _hoisted_7 = {
  class: "relative my-1"
};
const _hoisted_8 = {
  class: "text-base"
};
const _hoisted_9 = {
  class: "flex flex-col table-height w-full print:h-full bg-white shadow-sm"
};
const _hoisted_10 = {
  class: "overflow-y-auto print:overflow-hidden"
};
const _hoisted_11 = {
  class: "inline-block print:inline py-2 min-w-full align-middle"
};
const _hoisted_12 = {
  key: 1,
  class: "m-6 text-lg text-center font-semibold text-gray-800"
};
const _hoisted_13 = {
  key: 2,
  class: "min-w-full divide-y divide-gray-200 style-border"
};
const _hoisted_14 = {
  class: "py-3 px-4 print:whitespace-normal print:px-1 cursor-pointer"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
import { reactive, onMounted, watch } from "vue";
import { useExpenseStore } from "@/services/useExpenseStore";
import RouteService from "@/services/RouteService";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import QboExpense from "./QBOexpense.vue";
import MultipleAttachmentPreview from "../../components/MultipleAttachmentPreview.vue";
import Loader from "@/components/Loader.vue";
import MainHeader from "@/components/MainHeader.vue";
import { attachmentsToFileSelector } from "@/utils/attachmentsToFileSelector";
export default {
  __name: 'UnassignedTable',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: false
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    },
    http: {
      type: Function,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const expenseStore = useExpenseStore();
    const routeService = new RouteService(props);
    const vm = reactive({
      expenses: [],
      query: "",
      filter: {
        client: null
      },
      me: {
        terms: {
          matter: "Matter"
        }
      },
      showQboExpense: false,
      expenseId: null,
      orderby: "date",
      order: "asc",
      fileSelector: [],
      showAttachmentPreview: false
    });
    watch(() => vm.query, () => loadExpenses());
    onMounted(async () => {
      vm.me = await props.userService.getMe();
      loadExpenses();
    });
    const loadExpenses = () => {
      vm.loading = true;
      expenseStore.getUnassignedExpenses({
        order: vm.order,
        orderby: vm.orderby,
        assigned: false,
        search: vm.query
      }).then(({
        expenses
      }) => {
        vm.expenses = expenses;
        vm.expenses.forEach(e => {
          e.expenseType = expenseType(e);
        });
      }).finally(() => {
        vm.loading = false;
      });
    };
    const goToAnotherState = state => {
      routeService.go(state);
    };
    const viewAttachments = expense => {
      if (!expense.attachments?.length) return;
      vm.fileSelector = attachmentsToFileSelector(expense.attachments);
      vm.showAttachmentPreview = true;
    };
    const selected = entry => {
      vm.showQboExpense = true;
      vm.expenseId = entry.id;
    };
    function expenseType(expense) {
      if (expense.accounting) {
        return expense.accounting?.type == "Purchase" ? "Expense" : expense.accounting?.type;
      }
      return "LeanLaw";
    }
    const reload = updated => {
      vm.expenses = vm.expenses.map(e => e.id == updated.id ? updated : e).filter(e => !e.matter && !e.deleted);
      vm.showQboExpense = false;
    };
    const sort = s => {
      if (s === vm.orderby) {
        vm.order = vm.order === "asc" ? "desc" : "asc";
      }
      vm.orderby = s;
      loadExpenses();
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [vm.showQboExpense ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(QboExpense, {
        alerts: props.alerts,
        userService: props.userService,
        leanLawApi: props.leanLawApi,
        leanLawAuth: props.leanLawAuth,
        state: props.state,
        stateParams: props.stateParams,
        http: props.http,
        expenseId: vm.expenseId,
        onCancel: _cache[0] || (_cache[0] = () => vm.showQboExpense = false),
        onReload: reload
      }, null, 8, ["alerts", "userService", "leanLawApi", "leanLawAuth", "state", "stateParams", "http", "expenseId"])])) : _createCommentVNode("", true), _createVNode(_component_v_dialog, {
        modelValue: vm.showAttachmentPreview,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => vm.showAttachmentPreview = $event),
        width: "800"
      }, {
        default: _withCtx(() => [_createVNode(MultipleAttachmentPreview, {
          previewSource: vm.fileSelector,
          onCancel: _cache[1] || (_cache[1] = $event => vm.showAttachmentPreview = false),
          selectedFileIndex: 0
        }, null, 8, ["previewSource"])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_4, [_createVNode(LlSecondaryButton, {
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => goToAnotherState('expenses.list'), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Back to Expenses ", -1)]))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(MainHeader, {
        content: 'Unassigned Expenses'
      }), _createElementVNode("div", _hoisted_7, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "flex absolute inset-y-0 left-2 items-center pt-1 pl-3pointer-events-none",
        "aria-hidden": "true"
      }, [_createElementVNode("svg", {
        class: "mr-3 w-4 h-4 text-gray-400",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true"
      }, [_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
        "clip-rule": "evenodd"
      })])], -1)), _withDirectives(_createElementVNode("input", {
        type: "search",
        name: "search",
        id: "search",
        class: "block at-expense-search pr-6",
        style: {
          "width": "70%"
        },
        placeholder: "Search Expenses",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => vm.query = $event)
      }, null, 512), [[_vModelText, vm.query]])])]), _createElementVNode("p", _hoisted_8, " These are billable expenses from QuickBooks that are not assigned to a LeanLaw client and " + _toDisplayString(vm.me.terms.matter) + ". Click on an expense to assign it. ", 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [vm.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Unassigned Expenses',
        class: "mt-32"
      })) : !vm.expenses.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, " No Expenses match the filters ")) : (_openBlock(), _createElementBlock("table", _hoisted_13, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[22] || (_cache[22] = _createElementVNode("td", {
        class: "py-4 px-3.5 print:hidden text-xs font-medium text-center bg-gray-50"
      }, null, -1)), _createElementVNode("th", {
        onClick: _cache[5] || (_cache[5] = _withModifiers($event => sort('date'), ["prevent"])),
        class: "sticky top-0 py-4 px-4 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50 cursor-pointer"
      }, [_cache[13] || (_cache[13] = _createTextVNode(" Date ", -1)), _withDirectives(_createElementVNode("span", null, [_cache[12] || (_cache[12] = _createTextVNode("  ", -1)), _createElementVNode("span", {
        class: _normalizeClass(["no-print fa", vm.order === 'asc' ? 'fa-caret-up' : 'fa-caret-down'])
      }, null, 2)], 512), [[_vShow, vm.orderby === 'date']])]), _createElementVNode("th", {
        onClick: _cache[6] || (_cache[6] = _withModifiers($event => sort('type'), ["prevent"])),
        class: "sticky top-0 py-4 px-4 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50 cursor-pointer"
      }, [_cache[15] || (_cache[15] = _createTextVNode(" Type ", -1)), _withDirectives(_createElementVNode("span", null, [_cache[14] || (_cache[14] = _createTextVNode("  ", -1)), _createElementVNode("span", {
        class: _normalizeClass(["no-print fa", vm.order === 'asc' ? 'fa-caret-up' : 'fa-caret-down'])
      }, null, 2)], 512), [[_vShow, vm.orderby === 'type']])]), _withDirectives(_createElementVNode("th", {
        onClick: _cache[7] || (_cache[7] = _withModifiers($event => sort('client'), ["prevent"])),
        class: "sticky top-0 py-4 px-4 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50 cursor-pointer"
      }, [_cache[17] || (_cache[17] = _createTextVNode(" Client ", -1)), _withDirectives(_createElementVNode("span", null, [_cache[16] || (_cache[16] = _createTextVNode("  ", -1)), _createElementVNode("span", {
        class: _normalizeClass(["no-print fa", vm.order === 'asc' ? 'fa-caret-up' : 'fa-caret-down'])
      }, null, 2)], 512), [[_vShow, vm.orderby === 'client']])], 512), [[_vShow, !vm.filter?.client]]), _cache[23] || (_cache[23] = _createElementVNode("th", {
        class: "sticky top-0 py-4 px-4 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50 cursor-pointer"
      }, " Description ", -1)), _withDirectives(_createElementVNode("th", {
        onClick: _cache[8] || (_cache[8] = $event => sort('attachments')),
        class: "sticky top-0 py-4 px-4 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50 cursor-pointer"
      }, [_cache[19] || (_cache[19] = _createTextVNode(" Attachment ", -1)), _withDirectives(_createElementVNode("span", null, [_cache[18] || (_cache[18] = _createTextVNode("  ", -1)), _createElementVNode("span", {
        class: _normalizeClass(["no-print fa", vm.order === 'asc' ? 'fa-caret-up' : 'fa-caret-down'])
      }, null, 2)], 512), [[_vShow, vm.orderby === 'attachments']])], 512), [[_vShow, vm.me?.features?.expenseAttachments]]), _createElementVNode("th", {
        onClick: _cache[9] || (_cache[9] = _withModifiers($event => sort('amount'), ["prevent"])),
        class: "sticky top-0 py-4 px-4 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50 cursor-pointer"
      }, [_cache[21] || (_cache[21] = _createTextVNode(" Amount ", -1)), _withDirectives(_createElementVNode("span", null, [_cache[20] || (_cache[20] = _createTextVNode("  ", -1)), _createElementVNode("span", {
        class: _normalizeClass(["no-print fa", vm.order === 'asc' ? 'fa-caret-up' : 'fa-caret-down'])
      }, null, 2)], 512), [[_vShow, vm.orderby === 'amount']])])])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.expenses, (expense, ids) => {
        return _openBlock(), _createElementBlock("tr", {
          key: ids
        }, [_createElementVNode("td", _hoisted_14, [_withDirectives(_createElementVNode("span", null, [...(_cache[24] || (_cache[24] = [_createElementVNode("img", {
          src: "/img/qb10x10.png"
        }, null, -1)]))], 512), [[_vShow, expense.accounting]])]), _createElementVNode("td", {
          onClick: _withModifiers($event => selected(expense), ["prevent"]),
          class: "py-3 px-4 print:whitespace-normal print:px-1 cursor-pointer"
        }, _toDisplayString(_ctx.formatDate(expense?.date)), 9, _hoisted_15), _createElementVNode("td", {
          onClick: _withModifiers($event => selected(expense), ["prevent"]),
          class: "py-3 px-4 print:whitespace-normal print:px-1 cursor-pointer"
        }, _toDisplayString(expense?.expenseType), 9, _hoisted_16), _withDirectives(_createElementVNode("td", {
          onClick: _withModifiers($event => selected(expense), ["prevent"]),
          class: "py-3 px-4 print:whitespace-normal print:px-1 cursor-pointer"
        }, _toDisplayString(expense?.client?.label), 9, _hoisted_17), [[_vShow, !vm.filter?.client]]), _createElementVNode("td", {
          onClick: _withModifiers($event => selected(expense), ["prevent"]),
          class: "py-3 px-4 print:whitespace-normal print:px-1 cursor-pointer"
        }, _toDisplayString(expense?.description), 9, _hoisted_18), _withDirectives(_createElementVNode("td", {
          onClick: $event => viewAttachments(expense),
          class: "py-3 px-4 print:whitespace-normal print:px-1 cursor-pointer"
        }, [_withDirectives(_createVNode(_component_v_icon, {
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("mdi-paperclip", -1)]))]),
          _: 1
        }, 512), [[_vShow, expense?.attachments?.length]])], 8, _hoisted_19), [[_vShow, vm.me.features?.expenseAttachments]]), _createElementVNode("td", {
          class: "py-3 px-4 print:whitespace-normal print:px-1 cursor-pointer",
          onClick: _withModifiers($event => selected(expense), ["prevent"])
        }, _toDisplayString(_ctx.formatCurrency(expense?.amount)), 9, _hoisted_20)]);
      }), 128))])]))])])])])])]);
    };
  }
};